 const InitialFeedback = {
	firstname : '',
	lastname : '',
	Telno : '',
	email : '',
	agree : false,
	contactType : 'Tel.',
	message : ''
};

 export default InitialFeedback